(() => {
  const q = (s, root = document) => root.querySelector(s);
  const qa = (s, root = document) => [...root.querySelectorAll(s)];
  const money = (cents) => {
    try { return new Intl.NumberFormat(navigator.language, { style: 'currency', currency: window.STRAPPI?.currency || 'AUD' }).format((cents || 0) / 100); }
    catch { return `$${((cents || 0) / 100).toFixed(2)}`; }
  };

  const header = q('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-sticky', window.scrollY > 12);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  const mobileToggle = q('[data-mobile-menu-toggle]');
  const mobileMenu = q('[data-mobile-menu]');
  if (mobileToggle && mobileMenu) mobileToggle.addEventListener('click', () => {
    mobileMenu.hidden = !mobileMenu.hidden;
    mobileToggle.setAttribute('aria-expanded', String(!mobileMenu.hidden));
  });

  const search = q('[data-search-pop]');
  qa('[data-search-open]').forEach(btn => btn.addEventListener('click', () => {
    search?.classList.add('is-open'); q('input[type="search"]', search)?.focus();
  }));
  qa('[data-search-close]').forEach(btn => btn.addEventListener('click', () => search?.classList.remove('is-open')));

  const drawer = q('[data-cart-drawer]');
  const openCart = () => { drawer?.classList.add('is-open'); drawer?.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; };
  const closeCart = () => { drawer?.classList.remove('is-open'); drawer?.setAttribute('aria-hidden','true'); document.body.style.overflow=''; };
  qa('[data-cart-open]').forEach(btn => btn.addEventListener('click', async () => { await refreshCart(); openCart(); }));
  qa('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeCart));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  async function getCart() {
    const res = await fetch(`${window.STRAPPI?.routes?.cart || '/cart'}.js`, { headers: { Accept: 'application/json' }});
    if (!res.ok) throw new Error('Unable to load cart');
    return res.json();
  }

  function cartItemHtml(item, index) {
    const image = item.featured_image?.url ? `<img src="${item.featured_image.url}" alt="">` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${item.variant_title}</p>` : '';
    return `<article class="s-drawer__item">
      <a href="${item.url}">${image}</a>
      <div><h3><a href="${item.url}">${item.product_title}</a></h3>${variant}
        <div class="s-drawer__qty"><button type="button" data-cart-change data-line="${index+1}" data-qty="${Math.max(0,item.quantity-1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change data-line="${index+1}" data-qty="${item.quantity+1}" aria-label="Increase quantity">+</button></div>
      </div>
      <div class="s-drawer__item-price">${money(item.final_line_price)}</div>
    </article>`;
  }

  async function refreshCart() {
    if (!drawer) return;
    try {
      const cart = await getCart();
      qa('[data-cart-count]').forEach(el => el.textContent = `(${cart.item_count})`);
      const items = q('[data-cart-items]', drawer); const footer = q('[data-cart-footer]', drawer);
      if (cart.item_count === 0) {
        items.innerHTML = `<div class="s-empty-state"><p>Your bag is empty.</p><a class="s-button s-button--dark" href="/collections/all">SHOP STRAPPI</a></div>`;
        footer.hidden = true;
      } else {
        items.innerHTML = cart.items.map(cartItemHtml).join(''); footer.hidden = false;
        q('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
      }
    } catch (err) {
      const msg = q('[data-cart-message]', drawer); if (msg) { msg.hidden = false; msg.textContent = err.message; }
    }
  }

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-cart-change]'); if (!btn) return;
    btn.disabled = true;
    try {
      await fetch(`${window.STRAPPI?.routes?.cartChange || '/cart/change'}.js`, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ line:Number(btn.dataset.line), quantity:Number(btn.dataset.qty) }) });
      await refreshCart();
    } finally { btn.disabled = false; }
  });

  async function addForm(form) {
    const button = q('[type="submit"]', form); const status = q('[data-form-status]', form);
    button && (button.disabled = true); if (status) status.textContent = 'Adding…';
    try {
      const data = new FormData(form);
      const res = await fetch(`${window.STRAPPI?.routes?.cartAdd || '/cart/add'}.js`, { method:'POST', headers:{Accept:'application/json'}, body:data });
      const json = await res.json(); if (!res.ok) throw new Error(json.description || 'Could not add this item.');
      if (status) status.textContent = 'Added.'; await refreshCart(); openCart();
    } catch (err) { if (status) status.textContent = err.message; }
    finally { button && (button.disabled = false); }
  }

  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-strappi-product-form], .js-strappi-product-form');
    if (!form || e.submitter?.name === 'checkout') return;
    e.preventDefault(); addForm(form);
  });

  qa('[data-product-root]').forEach(root => {
    const variantsEl = q('[data-variants-json]', root); if (!variantsEl) return;
    let variants = []; try { variants = JSON.parse(variantsEl.textContent); } catch { return; }
    const form = q('[data-strappi-product-form]', root); const idInput = q('input[name="id"]', form);
    const price = q('[data-product-price]', root); const compare = q('[data-compare-price]', root); const add = q('[data-add-button]', root);
    const sticky = q('[data-mobile-buy]'); const stickyBtn = q('[data-mobile-buy-button]', sticky); const stickyPrice = q('[data-mobile-buy-price]', sticky);

    const selectedOptions = () => qa('[data-option-index]:checked', root).sort((a,b)=>Number(a.dataset.optionIndex)-Number(b.dataset.optionIndex)).map(i => i.value);
    const update = () => {
      const opts = selectedOptions(); const variant = variants.find(v => v.options.every((o,i) => o === opts[i])); if (!variant) return;
      idInput.value = variant.id; price.textContent = money(variant.price);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (compare) { compare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price ? money(variant.compare_at_price) : ''; compare.hidden = !compare.textContent; }
      add.disabled = !variant.available; add.textContent = variant.available ? `ADD TO BAG — ${money(variant.price)}` : 'SOLD OUT';
      if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT'; }
      if (variant.featured_media?.id) {
        const media = q(`[data-media-id="${variant.featured_media.id}"]`, root); if (media && window.innerWidth < 990) media.scrollIntoView({ behavior:'smooth', inline:'start', block:'nearest' });
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({},'',url);
    };
    qa('[data-option-index]', root).forEach(input => input.addEventListener('change', update));
    qa('[data-qty-action]', root).forEach(btn => btn.addEventListener('click', () => {
      const inp = q('input[name="quantity"]', form); const delta = btn.dataset.qtyAction === 'plus' ? 1 : -1; inp.value = Math.max(1, Number(inp.value || 1) + delta);
    }));
    stickyBtn?.addEventListener('click', () => addForm(form));
    if (sticky && form) {
      const observer = new IntersectionObserver(entries => { entries.forEach(entry => sticky.classList.toggle('is-visible', !entry.isIntersecting)); }, { threshold: .05 });
      const primary = q('[data-add-button]', root); if (primary) observer.observe(primary);
    }
  });

  qa('[data-kit-form]').forEach(form => {
    const total = q('[data-kit-total]', form); const checks = qa('[data-kit-check]', form);
    const calc = () => { total.textContent = money(checks.filter(c=>c.checked).reduce((sum,c)=>sum+Number(c.dataset.price||0),0)); };
    checks.forEach(c=>c.addEventListener('change', calc)); calc();
    form.addEventListener('submit', async e => {
      e.preventDefault(); const button = q('[type="submit"]', form); const status = q('[data-form-status]', form);
      const items = checks.filter(c=>c.checked).map(c => ({ id:Number(c.value), quantity:1 }));
      if (!items.length) { status.textContent='Choose at least one item.'; return; }
      button.disabled=true; status.textContent='Adding your kit…';
      try {
        const res = await fetch(`${window.STRAPPI?.routes?.cartAdd || '/cart/add'}.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const json = await res.json(); if(!res.ok) throw new Error(json.description || 'Could not add kit.');
        status.textContent='Added.'; await refreshCart(); openCart();
      } catch(err){ status.textContent=err.message; } finally { button.disabled=false; }
    });
  });
})();
